<template>
  <div>
    <div class="m-b-5">
      <form @submit.prevent="onFilesSubmit">
        <div class="is-clearfix">
          <field-file-multiple
            class="is-pulled-left m-t-2 m-r-2"
            required
            name="files"
            :value.sync="files"
            :disabled="uploadFilesLoading !== false"
            :label="$t('form.choose_files')"
          />
          <button
            v-if="files.length"
            class="button is-pulled-left is-primary m-t-2 m-r-2"
            :class="{ 'is-loading': uploadFilesLoading }"
            :disabled="uploadFilesLoading !== false"
          >{{ $t("form.upload") }}</button>
          <button
            v-if="files.length"
            @click="clearFiles"
            :disabled="uploadFilesLoading !== false"
            class="button is-primary m-t-2"
          >{{ $t("form.clear") }}</button>
        </div>
      </form>
    </div>
    <div class="m-b-3">
      <div v-for="file in active.files" :key="file.id">
        <div class="file">
          <a :href="file.uri" download>{{file.filename}}</a>
          <button
            class="button is-danger is-small m-l-3"
            :class="{'is-loading': removeFileLoading == file.id }"
            @click="removeFile(file.id)"
          >
            <i class="mdi mdi-trash-can-outline"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      removeFileLoading: false,
      uploadFilesLoading: false,
      files: []
    }
  },

  computed: {
    active() {
      return this.$store.state.users.active;
    }
  },

  methods: {
    async removeFile(file) {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removeFileLoading = file;
        try {
          await this.$api.deleteUserFile(file);
          this.$store.commit('users/REMOVE_USER_FILE', { file, user: this.active.id })
        } catch (e) {
          console.log(e);
          this.handleFormError(e.response.data);
        } finally {
          this.removeFileLoading = false;
        }

      }
    },

    clearFiles() {
      this.files = [];
    },

    async onFilesSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.uploadFilesLoading = true;

      const formData = new FormData();

      Array.from(this.files).forEach(e => {
        formData.append("files[]", e, e.name);
      });
      

      try {
        const { data } = await this.$api.uploadUserFiles(this.active.id, formData);
        await this.$store.dispatch('users/setActiveUser', this.active.id);
        this.clearFiles();
        this.$toast.success(data.message);
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      } finally {
        this.uploadFilesLoading = false;
      }

    }
  }
};
</script>

<style lang="scss" scoped>
.file {
  display: inline-block;

  .button {
    opacity: 0;
    pointer-events: none;
  }

  &:hover {
    button {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/users/_id/files.vue